import { Jsonld } from "../../jsonld";
import { getSearchAction } from "../action";
import { SCHEMA_CONTEXT, SCHEMA_DEFAULT_LANGUAGE } from "../schema-constants";
import type { WebsiteSchemaProps, WebSiteData } from "./website-schema.types";

export function WebsiteSchema({
  projectName,
  baseUrl,
  name,
  inLanguage = SCHEMA_DEFAULT_LANGUAGE,
  searchAction,
}: WebsiteSchemaProps): JSX.Element | null {
  if (!baseUrl) return null;

  const schemaTypeId = `jsonld_website_${projectName}`;

  const data = {
    "@context": SCHEMA_CONTEXT,
    "@type": "WebSite",
    name,
    url: baseUrl,
    inLanguage,
    ...(searchAction && { potentialAction: getSearchAction(searchAction) }),
  } satisfies WebSiteData;

  return <Jsonld id={schemaTypeId} dataSchema={data} dataQa={schemaTypeId} />;
}